import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { type FormControl, type FormGroup, ReactiveFormsModule } from '@angular/forms';

import { SymbolComponent } from '@core/symbol-legacy';
import { RadioComponent, Select2Component, type Select2Item } from '@core/user-interface-legacy';
import type { InputSelectConfig } from '@tellent-ask-hr/dynamic-forms-types';

import { RespondFormWrapperComponent } from '../../partials/respond-form-wrapper/respond-form-wrapper.component';

@Component({
  selector: 'input-radio-respond',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RespondFormWrapperComponent,
    ReactiveFormsModule,
    RadioComponent,
    Select2Component,
    SymbolComponent,
  ],
  template: `
    <respond-form-wrapper [answerConfig]="respondConfig()">
      @switch (respondConfig().kind) {
        @case ('radio') {
          @for (option of respondConfig().options; track option.value) {
            <rt-radio
              [value]="option.value"
              [disabled]="!!respondConfig().disabled"
              [checked]="respondForm().controls.value.value === option.value"
              (valueChange)="onValueChange($any($event))"
              [attr.margin-bottom-small-x]="!$last ? '' : null"
            >
              @if (option.symbol; as symbol) {
                <rt-symbol [symbol]="symbol" />
              }
              {{ option.label ?? option.value }}
            </rt-radio>
          }
        }
        @case ('dropdown') {
          <rt-select2
            [items]="selectItems()"
            [disabled]="!!respondConfig().disabled"
            [formControl]="respondForm().controls.value"
          />
        }
      }
    </respond-form-wrapper>
  `,
})
export class RespondSelectSingleComponent<T extends string> {
  public respondConfig = input.required<InputSelectConfig<T>>();
  public respondForm = input.required<
    FormGroup<{
      value: FormControl<T | null>;
    }>
  >();

  protected selectItems = computed(
    (): Array<Select2Item<T>> =>
      this.respondConfig().options.map(({ label, value }) => ({
        label: label ?? value,
        value,
      })),
  );

  protected onValueChange(value: T | null) {
    const control = this.respondForm().controls.value;
    control.setValue(value);
    control.markAllAsTouched();
    control.markAsDirty();
  }
}
